import React from 'react'

function IconButton({className, children, onClick}) {
  return <button className={`w-[24px] h-[24px] bg-transparent flex items-center justify-center ${className || ''}`} onClick={onClick}>{children}</button>
}

export default IconButton
